// extracted by mini-css-extract-plugin
export default {"cell-actions":"cell-actions--Tno_G","cellActions":"cell-actions--Tno_G","cell-actions__link":"cell-actions__link--A74Tb","cellActionsLink":"cell-actions__link--A74Tb"};